import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import { CognitoConfig } from './auth/aws-exports';
import '@aws-amplify/ui-react/styles.css';
import { ThemeProvider } from '@mui/material';
import { theme } from './ui/sgr/theme';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import 'moment/locale/it-ch';
import './locale/locale_config';

Amplify.configure(CognitoConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="it-ch">
        <Authenticator.Provider>
          {/*<Container disableGutters maxWidth={false}>*/}
          <App />
          {/*</Container>*/}
        </Authenticator.Provider>
      </LocalizationProvider>
    </ThemeProvider>
  </React.StrictMode>
);
